import { render, staticRenderFns } from "./FaqVideoInfo.vue?vue&type=template&id=00b6475c"
import script from "./FaqVideoInfo.vue?vue&type=script&lang=js"
export * from "./FaqVideoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports